export const account_list =[
    {
      id: "1",
      accountholder: "Zephyr Indira",
      accountno: "3298784309485",
      type: "Savings account",
      balance: "$200",
      note: "Savings accounts can be for children, seniors",
      status: "Active"
    },
    {
      id: "2",
      accountholder: "Quillon Elysia",
      accountno: "5475878970090",
      type: "Current Account",
      balance: "$50",
      note: "A deposit account for business",
      status: "Closed"
    },
    {
      id: "3",
      accountholder: "Thaddeus Juniper",
      accountno: "3255465758698",
      type: "Salary Account",
      balance: "$800",
      note: "Savings accounts can be for children, seniors",
      status: "Active"
    },
    {
      id: "4",
      accountholder: "Orion Astrid",
      accountno: "4353689870544",
      type: "Current Account",
      balance: "$100",
      note: "A deposit account for business",
      status: "Active"
    },
    {
      id: "5",
      accountholder: "Caspian Marigold",
      accountno: "4324356677889",
      type: "Current Account",
      balance: "$700",
      note: "A deposit account for business",
      status: "Active"
    },
    {
      id: "6",
      accountholder: "Emma James",
      accountno: "2343547586900",
      type: "Salary Account",
      balance: "$1000",
      note: "A deposit account for business",
      status: "Active"
    },
    {
      id: "7",
      accountholder: "Olivia Ethan",
      accountno: "3453647664889",
      type: "Current Account",
      balance: "$1200",
      note: "A type of bank account.",
      status: "Active"
    },
    {
      id: "8",
      accountholder: "Sophia Liam",
      accountno: "3354456565687",
      type: "Current Account",
      balance: "$750",
      note: "A deposit account for business",
      status: "Closed"
    },
    {
      id: "9",
      accountholder: "Ava Mason",
      accountno: "3456565767787",
      type: "Salary Account",
      balance: "$450",
      note: "A type of bank account.",
      status: "Active"
    },
    {
      id: "10",
      accountholder: "Isabella Jackson",
      accountno: "3434565776768",
      type: "Salary Account",
      balance: "$300",
      note: "A type of bank account.",
      status: "Active"
    },

  ]